/** The world's phone readers, from `@libs/utils/world` (LIS-1173), for this
 *  package's current callers. */
export {
  diallingCode,
  displayPhone,
  nationalPhone,
  phoneParts,
  readPhone,
  type DialledPhone,
} from "@libs/utils/world";
